import Cookies from "js-cookie";
import React, {useEffect, useState} from "react";
import {AxiosCustomGet} from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import Title from "../../components/common/Title/Title";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../components/helpers/IsEmpty";
import {Modal, Button, Input} from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../components/common/Table/CustomTable";
import {renderColumns} from "./constants";
import {TiUser} from "react-icons/ti";
import CustomDatePicker from "../../components/common/DatePicker/CustomDatePicker";

const ListPointWithdrawal = () => {
    const [id, setId] = useState();
    const [reason, setReason] = useState();
    const [paymentProof, setPaymentProof] = useState();
    const [records, setRecords] = useState([]);
    const [totalRecord, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState();
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [modalApprove, setModalApprove] = useState(0);
    const [modalReject, setModalReject] = useState(0);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tablePagination, setTablePagination] = useState({});
    const [searchTimeout, setSearchTimeout] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const handleSubmit = (isDelete = false) => {
        setSubmitting(true);

        let data = {
            name: reason,
        };

        if (IsEmpty(id)) {
            let url = `${process.env.REACT_APP_BASE_API_URL}point-withdrawal`;
            httpclient
                .POST(url, data)
                .then((response) => {
                    console.log(response);
                    SwalToast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    window.location.reload(false);
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data.error);
                        SwalToast.fire({
                            icon: "error",
                            title: error.response.data.error.message,
                        });
                    } else {
                        console.log(error);
                        SwalToast.fire({
                            icon: "error",
                            title: "Whoops, something went wrong",
                        });
                    }
                })
                .finally(() => {
                    setSubmitting(false);
                });
        } else {
            let url = `${process.env.REACT_APP_BASE_API_URL}point-withdrawal/${id}`;
            if (isDelete === true) {
                httpclient
                    .DELETE(url)
                    .then((response) => {
                        SwalToast.fire({
                            icon: "success",
                            title: response.data.message,
                        });
                        window.location.reload(false);
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.data.error);
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            console.log(error);
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                        }
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            } else {
                httpclient
                    .PUT(url, data)
                    .then((response) => {
                        SwalToast.fire({
                            icon: "success",
                            title: response.data.message,
                        });
                        window.location.reload(false);
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.data.error);
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            console.log(error);
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                        }
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            }
        }
    };

    const handleApprove = (record) => {
        setReason(record.name);
        setId(record.id);
        setModalApprove(true);
    };

    const handleReject = (record) => {
        setId(record.id);
        setModalReject(true);
    };

    const handleCloseModalApprove = () => {
        setModalApprove(false);
        setId("");
    };

    const handleCloseModalReject = () => {
        setModalReject(false);
        setReason("");
        setId("");
    };

    const getData = () => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}point-withdrawal?name=${search}&page=${page}&size=${pageSize}`;
        AxiosCustomGet(
            url,
            Config({
                Authorization: `Bearer ${Cookies.get("access_token")}`,
            }),
            (response) => {
                setLoading(false);
                console.log(response);

                setRecords(response.data.data.items);
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const searchData = (name) => {
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        setSearch(name);
        setSearchTimeout(setTimeout(function() {
            getData();
        }, 700));
    }

    return (
        <>
            <div>
                <div className="px-3">
                    <div className="py-4 d-flex justify-content-between" style={{fontSize: "13px"}}>
                        <div className="">
                            <Title text={"Pencairan Poin Komisi"}/>
                            <Breadcrumb current={"Pencairan Poin Komisi"}/>
                        </div>
                    </div>
                    <div className="d-flex pt-3">
                        <div className="">
                            <p className="m-0">Tampilkan:</p>
                            <input
                                type="number"
                                className="form-control border-97A0AE"
                                placeholder="Tampilkan"
                                onChange={(e) => searchData(e.target.value)}
                            />
                        </div>
                        <div className="ml-2">
                            <p className="m-0">Nama Nasabah:</p>
                            <input
                                type="text"
                                className="form-control border-97A0AE"
                                placeholder="Nama Nasabah"
                                onChange={(e) => searchData(e.target.value)}
                            />
                        </div>
                        <div className="ml-2">
                            <p className="m-0">Tanggal Pengajuan:</p>
                            <CustomDatePicker
                                isRangePicker
                                width="100%"
                                onInputChange={(e) => searchData(e)}
                            />
                        </div>
                    </div>
                    <div style={{marginTop: 24}}>
                        <CustomTable
                            columns={renderColumns(handleApprove, handleReject)}
                            data={records}
                            loading={loading}
                            // handleTableChange={handleTableChange}
                            pagination={tablePagination}
                        />
                    </div>
                </div>
            </div>

            <Modal
                className="modal-approve"
                centered
                title={`Proses Pencairan Poin`}
                visible={modalApprove}
                onOk={handleSubmit}
                onCancel={handleCloseModalApprove}
                footer={[
                    <Button
                        onClick={handleCloseModalApprove}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        type="submit"
                        disabled={submitting}
                        onClick={handleSubmit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#fff",
                            background: "#2C465C",
                        }}
                    >
                        Simpan
                    </Button>,
                ]}
            >
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div style={{color: "#A6A6A6"}}>Bukti Transfer :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="file"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Tambah File"
                            onChange={(e) => setPaymentProof(e)}
                        />
                        <p className="m-0 small">Format JPG/JPEG/PNG/PDF (Maks. 1MB)</p>
                    </div>
                </div>
            </Modal>

            <Modal
                className="modal-reject"
                centered
                title={"Batalkan Pencairan Poin"}
                visible={modalReject}
                onOk={handleSubmit}
                onCancel={handleCloseModalReject}
                footer={[
                    <Button
                        onClick={handleCloseModalReject}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        type="submit"
                        disabled={submitting}
                        onClick={handleSubmit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#fff",
                            background: "#EB2424",
                        }}
                    >
                        Batalkan
                    </Button>,
                ]}
            >
                <div className="mt-2">
                    <div className="color-A6A6A6">Berikan Alasan :</div>
                    <div className="mt-1">
                        <Input.TextArea
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Nomor rekening tidak sesuai"
                            onChange={(e) => setReason(e)}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ListPointWithdrawal;